import InitialsCircle from './IntitialsCircle'

export default InitialsCircle
